import React from 'react';
import PropTypes from 'prop-types';

export default class PopoverHelpHintDepricated extends React.Component {

    static propTypes = {
        defaultMessage: PropTypes.any,            // default message that is shown when no option is selected text or divs
        showIcon: PropTypes.bool,
        noBorder: PropTypes.bool,

        onCustomize: PropTypes.func
    };

    static defaultProps = {
        showIcon: true
    };

    state = {
        message: this.props.defaultMessage
    };

    setMessage = (message) => {
        this.setState({
            message: message ? message : this.props.defaultMessage
        });
    }

    render() {
        const classes = Classes('gd-popover-help-hint', this.props.className, {'no-border': this.props.noBorder});

        return (
            <div className={classes}>
                {this.state.message &&
                <React.Fragment>
                    {this.props.showIcon &&
                    <div className="help-info-icon">i</div>}
                    <div className="help-info-text">{this.state.message}</div>
                </React.Fragment>}

                {!this.state.message && this.props.onCustomize &&
                <div className="help-info-text ui5-link-small" onClick={this.props.onCustomize}>Customize</div>}
            </div>
        );

    }
}